import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Leaf, XCircle } from 'lucide-react';

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center" data-testid="payment-cancel-page">
      <div className="max-w-md w-full mx-auto p-8 text-center">
        {/* Logo */}
        <div className="flex items-center justify-center gap-2 mb-8">
          <div className="w-12 h-12 rounded-full gradient-primary flex items-center justify-center">
            <Leaf className="w-6 h-6 text-white" strokeWidth={1.5} />
          </div>
          <span className="text-3xl font-serif font-semibold">Twig</span>
        </div>

        <div className="space-y-6">
          <div className="w-20 h-20 mx-auto rounded-full bg-muted flex items-center justify-center">
            <XCircle className="w-10 h-10 text-muted-foreground" />
          </div>
          <h1 className="text-2xl font-serif font-semibold">Payment Cancelled</h1>
          <p className="text-muted-foreground">
            No worries! Your payment was cancelled and you haven't been charged. 
            You can try again whenever you're ready.
          </p>
          <div className="flex gap-3">
            <Button 
              variant="outline"
              onClick={() => navigate('/')}
              className="flex-1 rounded-xl"
            >
              Back to Home
            </Button>
            <Button 
              onClick={() => navigate('/payment')}
              className="flex-1 rounded-xl"
            >
              Try Again
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
